import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';

import { useAxios } from '../../context/AxiosContextProvider';
import useWorkshopQuery from '../useWorkshopQuery';

type UploadHandwerkskarteVariables = {
  handwerkskarte_uuids: string[];
};

async function uploadHandwerkskarte(axios: AxiosInstance, workshopId: number, variables: UploadHandwerkskarteVariables) {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v2/workshop-verification-request/workshop/${workshopId}/handwerkskarte`, variables);
  return data;
}

export default function useUploadWorkshopHandwerkskarteMutation(workshopId: number) {
  const queryClient = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: (variables: UploadHandwerkskarteVariables) => uploadHandwerkskarte(axios, workshopId, variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useWorkshopQuery.getKey(workshopId) });
    },
  });
}
